module.exports = __webpack_public_path__ + "static/media/icon-notification.30c17548.svg";